<script>
import ApiListing from "@core/components/common/expression-language/ApiListing.vue";
import SyntaxInformation from "@core/components/common/expression-language/SyntaxInformation.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

export default {
    components: {SyntaxInformation, ApiListing, AppCollapse, AppCollapseItem},
    props: {
        explanation: {
            required: true
        }
    },
}
</script>

<template>
    <div>
        <AppCollapse accordion>
            <AppCollapseItem title="Syntax information">
                <SyntaxInformation :explanation="explanation"/>
            </AppCollapseItem>
            <AppCollapseItem title="API Listing">
                <ApiListing :explanation="explanation"/>
            </AppCollapseItem>
        </AppCollapse>
    </div>
</template>
